import React from 'react';
import { useTranslation } from '../i18n';
import logo from '../images/bookie-logo.svg';

function NavbarLogo() {
  const { t } = useTranslation();
  return (
    <div key="wrapper" className="logotype">
      <img src={logo} alt="Bookie logo" width={148} height={48} />
      <h1 className="fs-m pt-65">{t.tagline}</h1>
    </div>
  );
}

export default NavbarLogo;
